<template>
  <div class="divider"></div>

  <div class="research-content">
    <div v-for="research in researchTopics" :key="research.id" class="research-section">
      <h1>{{ research.title }}</h1>

      <div class="short-description">
        <p style="text-indent: 2em">{{ research.description }}</p>
        <div class="image-section">
          <img :src="research.image" :alt="research.title" />
        </div>

        <!-- 使用 router-link 进行跳转 -->
        <router-link :to="{ name: 'ResearchDetail', params: { id: research.id } }">
          <el-button class="el-button">更多</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResearchView",
  data() {
    return {
      researchTopics: [] // 存放研究方向数据
    };
  },
  async mounted() {
    await this.fetchResearchData();
  },
  methods: {
    async fetchResearchData() {
      try {
        const response = await fetch("/research.json");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Fetched Research Data:", data); // 调试用
        this.researchTopics = data;
      } catch (error) {
        console.error("获取研究数据失败:", error);
      }
    }
  }
};
</script>
<style scoped>
.divider {
  height: 0.0625rem; /* 1px -> 0.0625rem */
  background-color: #ccc;
  margin: 1.25rem 0; /* 20px -> 1.25rem */
}

.research-content {
  padding: 0.625rem; /* 10px -> 0.625rem */
}

.short-description {
  position: relative;
  margin-bottom: 0px;
}

.el-button {
  position: absolute;
  bottom: 0.25rem; /* 10px -> 0.625rem */
  right: 0.625rem; /* 10px -> 0.625rem */
  background-color: #570303ee;
  color: white;
  font-size: 1.2rem;
  padding: 0rem 1.25rem; /* 10px 20px -> 0.625rem 1.25rem */
  border-radius: 0.5rem; /* 8px -> 0.5rem */
  box-shadow: 0 0.25rem 0.625rem rgba(0, 0, 0, 0.2); /* 4px 10px -> 0.25rem 0.625rem */
  transition: background-color 0.3s ease;
}

.el-button:hover {
  background-color: #8a0b0b;
}

.research-content h1 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.0625rem; /* 1px -> 0.0625rem */
  color: rgb(0, 0, 0);
  padding: 1.25rem 1.25rem; /* 20px 20px -> 1.25rem 1.25rem */
  border-radius: 0.625rem; /* 10px -> 0.625rem */
  margin-top: 0.625rem; /* 10px -> 0.625rem */
  text-align: center;
}

.research-content p {
  font-size: 1.4rem;
  line-height: 1.5;
  margin-bottom: 0.9375rem; /* 15px -> 0.9375rem */
}

.image-section {
  text-align: center;
  margin: 1.25rem 0; /* 20px -> 1.25rem */
}

.image-section img {
  max-width: 90%;
  height: auto;
  border-radius: 0.5rem; /* 图片圆角 */
  box-shadow: 0 0.625rem 1.875rem rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}

.video-section {
  text-align: center;
  margin: 1.25rem 0; /* 20px -> 1.25rem */
}

.video-section video {
  max-width: 90%;
  height: auto;
  border-radius: 0.5rem; /* 8px -> 0.5rem */
  box-shadow: 0 0.625rem 1.875rem rgba(0, 0, 0, 0.1); /* 10px 30px -> 0.625rem 1.875rem */
}
</style>